/* REQ-059 · a short, deliberate tap on the selected gallery photo opens the full-screen view its magnifier opens (Ran 01.11).
   Ran 20.10 removed an earlier photo tap because it caught scrolls on phones, so a tap counts only when it is clearly a tap:
   one pointer, <= 10px movement at every moment, <= 500ms, no page scroll, the slideshow did not move, and the browser's own
   click follows. Anything else (swipe, scroll, pinch, long press) behaves exactly as before. Delegated on the document, so it
   follows slideshow rebuilds (REQ-017/REQ-061 image sets); the magnifier is looked up at tap time, never cached. */
(function () {
  'use strict';
  var MOVE = 10, TIME = 500, SCROLL = 2, CLICK_WINDOW = 700;
  var SLIDE = '.product__main-photos .product-main-slide';
  var PHOTO = '.image-wrap, .pm-spdp-mock';
  var SKIP = 'button, a, input, select, textarea, label, video, model-viewer, iframe';
  var ZOOM = '.js-photoswipe__zoom, .pm-spdp-zoom';

  var g = null;          // the gesture in progress
  var pending = null;    // an accepted gesture waiting for its click
  var pointers = {};     // active pointers, to see a second finger
  var count = 0;

  function photoSlide(target) {
    if (!target || !target.closest || target.closest(SKIP)) return null;
    var photo = target.closest(PHOTO);
    var slide = photo && photo.closest(SLIDE);
    if (!slide) return null;
    // in a slideshow only the selected photo opens; a peeking neighbour does nothing new
    if (slide.closest('.flickity-enabled') && !slide.classList.contains('is-selected')) return null;
    return slide;
  }
  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;
  function slider(slide) {
    var el = slide.closest('.flickity-enabled');
    var F = el && window.Flickity && window.Flickity.data ? window.Flickity.data(el) : null;
    // the moment the slideshow starts a drag or changes slide, the gesture is a swipe (latched, not read at pointer-up)
    if (F && watched && !watched.has(F)) {
      watched.add(F);
      F.on('dragStart', swiped);
      F.on('change', swiped);
    }
    return F;
  }
  function swiped() { g = null; pending = null; }
  function cancel() { g = null; }

  document.addEventListener('pointerdown', function (e) {
    if (!pointers[e.pointerId]) { pointers[e.pointerId] = 1; count++; }
    pending = null;
    if (count > 1) { cancel(); return; }
    if (e.pointerType === 'mouse' && e.button !== 0) { cancel(); return; }
    var slide = photoSlide(e.target);
    if (!slide) { cancel(); return; }
    var F = slider(slide);
    g = { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), sy: window.scrollY, slide: slide,
          F: F, fx: F ? F.x : 0, fi: F ? F.selectedIndex : 0 };
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!g || e.pointerId !== g.id) return;
    if (Math.abs(e.clientX - g.x) > MOVE || Math.abs(e.clientY - g.y) > MOVE) cancel();
  }, true);

  function release(e) {
    if (pointers[e.pointerId]) { delete pointers[e.pointerId]; count--; }
  }
  document.addEventListener('pointerup', function (e) {
    release(e);
    if (!g || e.pointerId !== g.id) return;
    var ok = Date.now() - g.t <= TIME
      && Math.abs(e.clientX - g.x) <= MOVE && Math.abs(e.clientY - g.y) <= MOVE
      && Math.abs(window.scrollY - g.sy) <= SCROLL
      && (!g.F || (g.F.selectedIndex === g.fi && Math.abs(g.F.x - g.fx) <= 2 && !g.F.isDragging));
    if (ok) pending = { slide: g.slide, t: Date.now() };
    cancel();
  }, true);
  document.addEventListener('pointercancel', function (e) { release(e); cancel(); pending = null; }, true);
  window.addEventListener('scroll', function () { if (g && Math.abs(window.scrollY - g.sy) > SCROLL) cancel(); }, { passive: true });

  document.addEventListener('click', function (e) {
    var p = pending;
    pending = null;
    if (!p || e.defaultPrevented || Date.now() - p.t > CLICK_WINDOW) return;
    if (photoSlide(e.target) !== p.slide) return;
    if (document.querySelector('.pswp--open, .pm-mockview')) return;
    var zoom = p.slide.querySelector(ZOOM);
    if (zoom) zoom.click();
  });
})();
